export const LinkIcon = ({ size, className }: { size: number; className?: string }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4598 7.60533C11.9043 7.68973 12.2841 7.81634 12.5992 7.98514C12.92 8.15395 13.1957 8.35089 13.4264 8.57596C14.0903 9.23993 14.5321 9.97424 14.7515 10.7789C14.9766 11.5779 14.9766 12.3769 14.7515 13.1759C14.5321 13.9749 14.0932 14.7036 13.4348 15.362L10.6411 18.1557C9.98274 18.814 9.25406 19.2529 8.45504 19.4724C7.65603 19.6975 6.8542 19.7003 6.04956 19.4808C5.25055 19.2614 4.51905 18.8168 3.85509 18.1473C3.18549 17.4833 2.74097 16.7518 2.52152 15.9528C2.30207 15.1481 2.30207 14.3463 2.52152 13.5473C2.74659 12.7483 3.1883 12.0196 3.84664 11.3613L6.10864 9.1077C6.02987 9.43406 6.01017 9.7773 6.04956 10.1374C6.09458 10.4975 6.18179 10.8323 6.31121 11.1418L5.02829 12.4247C4.58939 12.8693 4.29398 13.3588 4.14206 13.8933C3.99576 14.4279 3.99576 14.9624 4.14206 15.497C4.29398 16.0316 4.5922 16.5211 5.03673 16.9656C5.48125 17.4101 5.97078 17.7055 6.50534 17.8518C7.03989 18.0038 7.57444 18.0038 8.10899 17.8518C8.64354 17.7055 9.13308 17.4101 9.5776 16.9656L12.2447 14.3069C12.6893 13.8624 12.9847 13.3729 13.131 12.8383C13.2829 12.3038 13.2829 11.7692 13.131 11.2347C12.9847 10.6945 12.6893 10.2021 12.2447 9.7576C12.0028 9.52128 11.7102 9.32996 11.3669 9.18366C11.0293 9.03174 10.6326 8.93327 10.1769 8.88825L11.4598 7.60533ZM10.5314 14.3998C10.0868 14.3097 9.70421 14.1803 9.38348 14.0115C9.06274 13.8427 8.78984 13.6486 8.56477 13.4291C7.89517 12.7595 7.45065 12.0252 7.2312 11.2262C7.01738 10.4272 7.02019 9.62819 7.23964 8.82917C7.45909 8.03016 7.89798 7.30148 8.55633 6.64314L11.3585 3.8494C12.0112 3.18543 12.7371 2.74372 13.5361 2.52427C14.3351 2.2992 15.1341 2.2992 15.9331 2.52427C16.7322 2.74372 17.4665 3.18824 18.1361 3.85784C18.8 4.52181 19.2417 5.25612 19.4612 6.06076C19.6863 6.85977 19.6891 7.65878 19.4696 8.4578C19.2502 9.25119 18.8085 9.97986 18.1445 10.6438L15.8825 12.8974C15.9613 12.5654 15.9782 12.2194 15.9331 11.8592C15.8938 11.4991 15.8094 11.1671 15.6799 10.8633L16.9544 9.58036C17.3989 9.13584 17.6943 8.64911 17.8406 8.12019C17.9926 7.58564 17.9926 7.05108 17.8406 6.51653C17.6943 5.97635 17.3989 5.48119 16.9544 5.03104C16.5043 4.58652 16.0119 4.29111 15.4774 4.14481C14.9428 3.99851 14.4083 3.99851 13.8737 4.14481C13.3392 4.29111 12.8524 4.58652 12.4135 5.03104L9.73797 7.69817C9.29907 8.14269 9.00366 8.63223 8.85174 9.16678C8.70544 9.70133 8.70544 10.2359 8.85174 10.7704C9.00366 11.305 9.3047 11.7945 9.75485 12.239C9.98555 12.481 10.2697 12.6779 10.6073 12.8299C10.9506 12.9762 11.3501 13.0718 11.8058 13.1168L10.5314 14.3998Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const UpdateIcon = ({ size }: { size: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 4v6h6M23 20v-6h-6M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UndoIcon = ({ size, className }: { size: number; className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g opacity="0.2">
        <path
          d="M2.07999 5.33329C2.35333 5.33329 3.07999 5.33329 3.07999 5.33329C3.07999 6.89329 4.35333 8.16663 5.91333 8.16663H13.2467C13.52 8.16663 13.7467 8.39329 13.7467 8.66663C13.7467 8.93996 13.52 9.16663 13.2467 9.16663H5.91333C3.79999 9.16663 2.07999 7.44663 2.07999 5.33329Z"
          fill="white"
        />
        <path
          d="M11.7133 6.50008C11.84 6.50008 11.9667 6.54674 12.0667 6.64674L13.7733 8.35341C13.9667 8.54674 13.9667 8.86674 13.7733 9.06008L12.0667 10.7667C11.8733 10.9601 11.5533 10.9601 11.36 10.7667C11.1667 10.5734 11.1667 10.2534 11.36 10.0601L12.7133 8.70674L11.36 7.35341C11.1667 7.16008 11.1667 6.84008 11.36 6.64674C11.4533 6.54674 11.5867 6.50008 11.7133 6.50008Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export const ArrowUpDownIcon = ({ size, className }: { size: number; className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" className={className}>
      <path
        d="M10.9799 6.19L7.26994 2.48C7.19994 2.41 7.10994 2.35 7.00994 2.31C6.99994 2.31 6.98994 2.31 6.97994 2.3C6.89994 2.27 6.81994 2.25 6.72994 2.25C6.52994 2.25 6.33994 2.33 6.19994 2.47L2.46994 6.19C2.17994 6.48 2.17994 6.96 2.46994 7.25C2.75994 7.54 3.23994 7.54 3.52994 7.25L5.97994 4.8V21C5.97994 21.41 6.31994 21.75 6.72994 21.75C7.13994 21.75 7.47994 21.41 7.47994 21V4.81L9.91994 7.25C10.0699 7.4 10.2599 7.47 10.4499 7.47C10.6399 7.47 10.8299 7.4 10.9799 7.25C11.2699 6.96 11.2699 6.49 10.9799 6.19Z"
        fill="currentColor"
      />
      <path
        d="M21.53 16.75C21.24 16.46 20.76 16.46 20.47 16.75L18.02 19.2V3C18.02 2.59 17.68 2.25 17.27 2.25C16.86 2.25 16.52 2.59 16.52 3V19.19L14.08 16.75C13.79 16.46 13.31 16.46 13.02 16.75C12.73 17.04 12.73 17.52 13.02 17.81L16.73 21.52C16.8 21.59 16.89 21.65 16.99 21.69C17 21.69 17.01 21.69 17.02 21.7C17.1 21.73 17.19 21.75 17.28 21.75C17.48 21.75 17.67 21.67 17.81 21.53L21.53 17.81C21.82 17.51 21.82 17.04 21.53 16.75Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const UndoArrowIcon = ({ size, className }: { size: number; className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M10.0867 3.29329H4.75333C4.47999 3.29329 4.25333 3.51996 4.25333 3.79329C4.25333 4.06663 4.47999 4.29329 4.75333 4.29329H10.0867C11.6467 4.29329 12.92 5.56663 12.92 7.12663C12.92 8.68663 11.6467 9.95996 10.0867 9.95996H2.75333C2.47999 9.95996 2.25333 10.1866 2.25333 10.46C2.25333 10.7333 2.47999 10.96 2.75333 10.96H10.0867C12.2 10.96 13.92 9.23996 13.92 7.12663C13.92 5.01329 12.2 3.29329 10.0867 3.29329Z"
        fill="currentColor"
      />
      <path
        d="M4.28666 8.29329C4.16 8.29329 4.03333 8.33996 3.93333 8.43996L2.22667 10.1466C2.03333 10.34 2.03333 10.66 2.22667 10.8533L3.93333 12.56C4.12667 12.7533 4.44667 12.7533 4.64 12.56C4.83333 12.3666 4.83333 12.0466 4.64 11.8533L3.28666 10.5L4.64 9.14662C4.83333 8.95329 4.83333 8.63329 4.64 8.43996C4.54667 8.33996 4.41333 8.29329 4.28666 8.29329Z"
        fill="currentColor"
      />
    </svg>
  )
}
